<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage" id="titlepage">
<h1><span class="title drsugiyama">The Book of<br/>
<span class="fs150">The Thousand Nights and a Night-volume2</span></span></h1>
<h3 class="sigil_not_in_toc">A Plain and Literal Translation of the Arabian Nights Entertainments</h3>
<h2 class="sigil_not_in_toc">Translated and Annotated by<br/>
<span class="fs200">Richard F. Burton<br/></span></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2c94aeaa